module.exports = __webpack_public_path__ + "img/folha.908d056b.svg";